var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLock = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "svg-lock__a",
  d: "M7.893.7a4.507 4.507 0 0 1 4.488 4.284l.005.21V8.29h3.196v10.99H.2V8.29l3.196-.001V5.193A4.507 4.507 0 0 1 7.893.7Zm6.689 8.59H1.199v8.988h13.383V9.29Zm-6.69 1.398a2.098 2.098 0 0 1 .5 4.136v2.057h-1l-.001-2.057a2.099 2.099 0 0 1 .5-4.136Zm0 1a1.098 1.098 0 1 0 0 2.196 1.098 1.098 0 0 0 0-2.196Zm0-9.988a3.507 3.507 0 0 0-3.49 3.303l-.006.192V8.29h6.99V5.196A3.506 3.506 0 0 0 7.893 1.7Z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(4 2)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "svg-lock__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#svg-lock__a"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#svg-lock__a",
  fill: "currentColor",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#svg-lock__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20-2H-4v24h24z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLock);
export default ForwardRef;